import { useState } from 'react';

const features = [
  {
    icon: 'ri-flashlight-line',
    title: 'Anında Eşleşme',
    desc: 'Ortalama 2 saniyede yeni bir insanla bağlantı kur. Dünya genelindeki aktif kullanıcı ağı sayesinde beklemeden devam et.',
    color: 'from-cyan-500 to-blue-600',
    glow: 'cyan',
  },
  {
    icon: 'ri-global-line',
    title: 'Dünya Geneli Bağlantı',
    desc: '180\'den fazla ülkede kullanıcılar. Farklı kültürlerden insanlarla tanış, dil engeline takılma.',
    color: 'from-violet-500 to-purple-700',
    glow: 'violet',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Akıllı Filtreleme',
    desc: 'Cinsiyet, ülke ve ilgi alanı filtrelerinizi ayarla. Sana en uygun kişilerle eşleş, zamanını boşa harcama.',
    color: 'from-cyan-400 to-cyan-600',
    glow: 'cyan',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Güvenli Sohbet',
    desc: '18+ doğrulama, AI moderasyon, anlık raporlama. Her sohbette güvende olduğunu hissedersin.',
    color: 'from-emerald-400 to-teal-600',
    glow: 'emerald',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Mobil Uyumlu',
    desc: 'iPhone, Android, tablet — her cihazda kusursuz çalışır. Native app hissi, tarayıcıdan erişim.',
    color: 'from-violet-400 to-pink-600',
    glow: 'violet',
  },
  {
    icon: 'ri-hd-line',
    title: 'HD Kalite Video',
    desc: 'Düşük bant genişliğinde bile kesintisiz HD görüntü. Akıllı sıkıştırma teknolojisiyle mükemmel deneyim.',
    color: 'from-orange-400 to-rose-500',
    glow: 'orange',
  },
];

const glowColors: Record<string, string> = {
  cyan: 'group-hover:shadow-cyan-500/20 group-hover:border-cyan-500/40',
  violet: 'group-hover:shadow-violet-500/20 group-hover:border-violet-500/40',
  emerald: 'group-hover:shadow-emerald-500/20 group-hover:border-emerald-500/40',
  orange: 'group-hover:shadow-orange-500/20 group-hover:border-orange-500/40',
};

const FeaturesSection = () => {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section id="features" className="py-24 md:py-32 bg-[#060810] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-violet-600/5 blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-violet-500/10 border border-violet-500/25 text-violet-400 text-xs font-semibold mb-6">
            <i className="ri-sparkling-line" />
            Premium Özellikler
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            Neden ChatNow?
          </h2>
          <p className="text-white/45 text-base md:text-lg max-w-xl mx-auto">
            Rakiplerinden ayrışan özellikler. Hız, güvenlik ve kaliteyi bir arada sun.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div
              key={f.title}
              className={`group relative p-6 rounded-2xl bg-white/3 border border-white/8 hover:bg-white/5 transition-all duration-300 cursor-default ${glowColors[f.glow]} hover:shadow-2xl`}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              {/* Icon */}
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${f.color} mb-5 transition-transform duration-300 ${hovered === i ? 'scale-110' : ''}`}
              >
                <i className={`${f.icon} text-white text-xl`} />
              </div>
              <h3 className="text-white font-bold text-lg mb-2">{f.title}</h3>
              <p className="text-white/45 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
